import './FilterSidebar.css'

const categories = ['Roofing Systems', 'Wall Systems', 'Metal Materials', 'Accessories', 'Insulation Solutions']
const materials = ['PIR Core', 'Steel', 'Aluminum', 'Other']

function CheckList({ items }: { items: string[] }) {
  return (
    <div className="filter-sidebar__checklist mt-3 space-y-2 text-sm">
      {items.map((item) => (
        <label key={item} className="filter-sidebar__check flex items-center gap-2">
          <input name={`filter-${item.toLowerCase().replaceAll(' ', '-')}`} type="checkbox" className="h-4 w-4" />
          {item}
        </label>
      ))}
    </div>
  )
}

function FilterContent() {
  return (
    <div className="filter-sidebar__content space-y-7">
      <section>
        <div className="filter-sidebar__section-title flex justify-between font-extrabold"><h3>CATEGORIES</h3><span>−</span></div>
        <CheckList items={categories} />
      </section>
      <section>
        <div className="filter-sidebar__section-title flex justify-between font-extrabold"><h3>THICKNESS</h3><span>−</span></div>
        <div className="filter-sidebar__range mt-4 flex items-center gap-2 text-xs"><span>20 mm</span><div className="filter-sidebar__range-track relative h-1 flex-1"><span className="filter-sidebar__range-thumb filter-sidebar__range-thumb--start absolute -left-1.5 -top-1.5 h-4 w-4 rounded-full" /><span className="filter-sidebar__range-thumb filter-sidebar__range-thumb--end absolute -right-1.5 -top-1.5 h-4 w-4 rounded-full" /></div><span>200 mm</span></div>
        <div className="filter-sidebar__range-values mt-4 flex justify-between"><span className="filter-sidebar__range-value px-2 py-1 text-xs">20 mm</span><span className="filter-sidebar__range-value px-2 py-1 text-xs">200 mm</span></div>
      </section>
      <section>
        <div className="filter-sidebar__section-title flex justify-between font-extrabold"><h3>MATERIAL</h3><span>−</span></div>
        <CheckList items={materials} />
      </section>
      {['COLOR AVAILABILITY', 'PRICE RANGE'].map((label) => <div key={label} className="filter-sidebar__section-title flex justify-between font-extrabold"><span>{label}</span><span>+</span></div>)}
      <button type="button" className="filter-sidebar__reset h-10 w-full text-sm font-extrabold">RESET FILTERS</button>
    </div>
  )
}

export default function FilterSidebar() {
  return (
    <>
       <aside className="filter-sidebar hidden min-[900px]:block">
        <div className="filter-sidebar__heading mb-7 flex items-center gap-5 font-extrabold"><span>FILTER PRODUCTS</span><button type="button" className="text-xs">↻ Reset all</button></div>
        <FilterContent />
      </aside>
      <details className="filter-sidebar__mobile bg-white px-4 py-3 min-[900px]:hidden">
        <summary className="cursor-pointer list-none font-extrabold">FILTER PRODUCTS <span className="float-right">+</span></summary>
        <div className="mt-5"><FilterContent /></div>
      </details>
    </>
  )
}
